<div class="selected-billets-panel" *ngIf="count > 0">
    <div class="selected-billets-info">
        <div class="selected-billets-label">Boletos selecionados</div>
        <div class="selected-billets-count">{{ count }}</div>
        <div class="selected-billets-total">Total: R$ {{ total | number: '1.2-2' }}</div>
    </div>
    <button mat-flat-button color="accent" type="button" [disabled]="disabled" (click)="confirm.emit()">
        Confirmar
    </button>
</div>